import { EXERCISE_LOG_SUMMARY_KEY } from '../../constants'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function getEstimatedOneRepMaxExerciseLogSummaryUtil (instance) {
  return getValueReduxUtil(
    instance,
    EXERCISE_LOG_SUMMARY_KEY.ESTIMATED_ONE_REP_MAX
  )
}

export default getEstimatedOneRepMaxExerciseLogSummaryUtil
